module.exports = __webpack_public_path__ + "fonts/MavenPro-Regular.c525be44.ttf";